import React, { useState, useEffect } from 'react'
import { message } from 'antd';
import { fetchAllEvents } from '../../../requests/events';
import EventList from '../../../components/EventList';

const AllEvents = () => {
    const [eventList, setEventList] = useState<any>(null);
    const fetchData = () => {
        fetchAllEvents().then(response => {
            setEventList(response)
            if(!response || !response.length) {
                message.info("No events are getting streamed now", 1)
            }
        }).catch(err => {
            message.error("Error in fetching events, Please contact the admin", 2)
        })
    }
    useEffect(() => {
        fetchData()
    }, [])
    return (
        <div>
            <EventList events={eventList} />
        </div>
    )
}

export default AllEvents;